var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleBalanceBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 2.5C8.94181 2.5 8.00015 3.16667 7.65015 4.16667H2.50015V5.83333H4.12515L1.66681 11.6667C1.27515 13.3333 2.50015 14.1667 4.58348 14.1667C6.66681 14.1667 7.96681 13.3333 7.50015 11.6667L5.04181 5.83333H7.64181C7.91681 6.54167 8.45848 7.08333 9.16681 7.35833V16.6667H1.66681V18.3333H18.3335V16.6667H10.8335V7.35C11.5418 7.08333 12.0835 6.54167 12.3501 5.83333H14.9585L12.5001 11.6667C12.1085 13.3333 13.3335 14.1667 15.4168 14.1667C17.5001 14.1667 18.8001 13.3333 18.3335 11.6667L15.8751 5.83333H17.5001V4.16667H12.3585C12.0001 3.16667 11.0585 2.5 10.0001 2.5ZM10.0001 4.16667C10.2212 4.16667 10.4331 4.25446 10.5894 4.41074C10.7457 4.56702 10.8335 4.77899 10.8335 5C10.8335 5.22101 10.7457 5.43298 10.5894 5.58926C10.4331 5.74554 10.2212 5.83333 10.0001 5.83333C9.77913 5.83333 9.56717 5.74554 9.41089 5.58926C9.25461 5.43298 9.16681 5.22101 9.16681 5C9.16681 4.77899 9.25461 4.56702 9.41089 4.41074C9.56717 4.25446 9.77913 4.16667 10.0001 4.16667ZM4.58348 8.54167L5.83348 11.6667H3.33348L4.58348 8.54167ZM15.4168 8.54167L16.6668 11.6667H14.1668L15.4168 8.54167Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleBalanceBlack);
export default __webpack_public_path__ + "static/media/scale-balance-black.458287deafe34705bff9dffa15cae8e7.svg";
export { ForwardRef as ReactComponent };